<block-ui>
    <div class="row p-1 d-flex justify-content-start">
        <div>
            <button class="form-control form-control-sm btn-light shadow-sm btn-st" (click)="NewConnection(content)">
                <i class="fa fa-plus" aria-hidden="true"></i> Agregar
            </button>
        </div>
    </div>
    <div class="row mt-2 tableFixHead">
        <table class="table table-striped table-sm table-hover">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Conexión</th>
                    <th scope="col">Servidor</th>
                    <th scope="col" class="text-center">Activo</th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let connection of connections; let i = index" class="p-0">
                    <td scope="row">{{(i + 1)}}</td>
                    <td>{{connection.Name}}</td>
                    <td>{{connection.Server}}</td>
                    <td class="text-center"><i class="fa fa-{{connection.Status ? 'check': 'times'}}"></i></td>
                    <td class="justify-content-center option clasesita">
                        <i class="fa fa-edit" style="cursor: pointer;" title="Editar usuario" (click)="EditConnection(content, connection)"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <ng-template #content let-modal>
        <div class="modal-header">
            <h5 class="modal-title">Conexión</h5>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form class="row" [formGroup]="connectionForm">
                <div class="form-group col-4">
                    <label>Nombre de la conexión</label>
                    <input type="text" class="form-control form-control-sm" formControlName="Name">
                </div>
                <div class="form-group col-4">
                    <label>Servidor</label>
                    <input type="text" class="form-control form-control-sm" formControlName="Server">
                </div>
                <div class="form-group col-4">
                    <label>DST</label>
                    <input type="text" class="form-control form-control-sm" formControlName="DST">
                </div>
                <div class="form-group col-6">
                    <label>Usuario base de datos</label>
                    <input type="text" class="form-control form-control-sm" formControlName="DBUser">
                </div>
                <div class="form-group col-6">
                    <label>Contraseña base de datos</label>
                    <div class="form-check form-check-inline w-100">
                        <input type="password" class="form-control form-control-sm mr-2 " formControlName="DBPass" [readonly]="!connectionForm.controls.UpdatePassword.value">
                        <input class="form-check-inputm ml-2" formControlName="UpdatePassword" type="checkbox" style="transform: scale(1.5); cursor: pointer" title="Editar contraseña" (click)="connectionForm.controls.DBPass.setValue('')">
                    </div>
                </div>
                <div class="form-group col-4">
                    <label>Tipo de ODBC</label>
                    <input type="text" class="form-control form-control-sm" formControlName="ODBCType">
                </div>
                <div class="form-group col-4">
                    <label>Motor de base de datos </label>
                    <input type="text" class="form-control form-control-sm" formControlName="DBEngine">
                </div>
                <div class="form-group col-4">
                    <label>Tipo de Servidor</label>
                    <input type="text" class="form-control form-control-sm" formControlName="ServerType">
                </div>
                <div class="form-check col-2 ml-4 mt-2">
                    <input type="checkbox" class="form-check-input" formControlName="Trusted" style="transform: scale(1.5); cursor: pointer">
                    <label class="form-check-label">Trusted</label>
                </div>
                <div class="form-group col-2 ml-4 mt-2">
                    <input type="checkbox" class="form-check-input" formControlName="Status" style="transform: scale(1.5); cursor: pointer">
                    <label class="form-check-label">Estado</label>
                </div>
            </form>

            <div class="row">
                <div class="col-sm-4 offset-sm-4">
                    <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st float-right" (click)="StoreConnection()"><i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar</button>
                </div>
                <div class="col-sm-4">
                    <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st" (click)="modal.dismiss('close click')"><i class="fa fa-times-circle" aria-hidden="true"></i> Cerrar&nbsp;</button>
                </div>
            </div>
        </div>
    </ng-template>
</block-ui>
